import { useIntl } from 'react-intl'
import { useLocation, useParams, Link } from 'react-router'

export function MenuInner() {
  const intl = useIntl()
  const location = useLocation()
  const { orderId, documentId } = useParams()

  const pageTitleMap: Record<string, string> = {
    '/': intl.formatMessage({ id: 'MENU.HOME' }),
    '/dashboard': intl.formatMessage({ id: 'MENU.DASHBOARD' }),
    '/profile': intl.formatMessage({ id: 'MENU.PROFILE' }),
    '/documents': intl.formatMessage({ id: 'MENU.DOCUMENTS' }),
    '/orders': intl.formatMessage({ id: 'MENU.ORDERS' }),
    '/status': intl.formatMessage({ id: 'MENU.SYSTEM_STATUS' }),
    '/documentDetails': intl.formatMessage({ id: 'MENU.DOCUMENT_DETAILS' }),
    '/orderDetails': intl.formatMessage({ id: 'MENU.ORDER_DETAILS' }),
  }

  const getSubTitle = () => {
    if (location.pathname.startsWith('/orders') && orderId) {
      return `${intl.formatMessage({ id: 'MENU.ORDER_NUMBER' })}: ${orderId}`
    }
    if (location.pathname.startsWith('/documents') && documentId) {
      return `${intl.formatMessage({ id: 'MENU.DOCUMENT_NUMBER' })}: ${documentId}`
    }
    return null
  }

  const pathKey = `/${location.pathname.split('/')[1]}`
  const pageTitle = pageTitleMap[pathKey] || intl.formatMessage({ id: 'MENU.HOME' })
  const subTitle = getSubTitle()

  return (
    <div className="page-title d-flex align-items-center flex-wrap me-3">
      <h1 className="page-heading d-flex text-gray-900 fw-bold fs-3 align-items-center my-0">
        {pageTitle}
      </h1>
      {subTitle && (
        <h2 className="page-subheading d-flex text-gray-700 fw-semibold fs-5 align-items-center my-0 ms-3">
          {subTitle}
        </h2>
      )}
      <span className="h-20px border-gray-300 border-start mx-4"></span>
      <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0">
        <li className="breadcrumb-item text-muted">
          <Link to="/dashboard" className="text-muted text-hover-primary">
            {intl.formatMessage({ id: 'MENU.HOME' })}
          </Link>
        </li>
        <li className="breadcrumb-item">
          <span className="bullet bg-gray-500 w-5px h-2px"></span>
        </li>
        <li className="breadcrumb-item text-muted">{pageTitle}</li>
        {subTitle && (
          <>
            <li className="breadcrumb-item">
              <span className="bullet bg-gray-500 w-5px h-2px"></span>
            </li>
            <li className="breadcrumb-item text-muted">{subTitle}</li>
          </>
        )}
      </ul>
    </div>
  )
}
